import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { setClassFilter, WildlifeClass } from '~app/actions/wildlife';

import WildlifeClassSelectorButton from './WildlifeClassSelectorButton';

const WildlifeClassSelector = (props) => {
  return (
    <div className="WildlifeClassSelector">

      <WildlifeClassSelectorButton
        title="Reptiles"
        speciesCount={props.countReptiles}
        selected={props.activeClassFilter === WildlifeClass.reptile}
        styleName={"reptiles"}
        onClick={() => props.setClassFilter(props.wildlifeContext, WildlifeClass.reptile)}
      />

      <WildlifeClassSelectorButton
        title="Amphibians"
        speciesCount={props.countAmphibians}
        selected={props.activeClassFilter === WildlifeClass.amphibian}
        styleName={"amphibians"}
        onClick={() => props.setClassFilter(props.wildlifeContext, WildlifeClass.amphibian)}
      />

      <WildlifeClassSelectorButton
        title="Mammals"
        speciesCount={props.countMammals}
        selected={props.activeClassFilter === WildlifeClass.mammal}
        styleName={"mammals"}
        onClick={() => props.setClassFilter(props.wildlifeContext, WildlifeClass.mammal)}
      />

    </div>
  );
};

WildlifeClassSelector.propTypes = {
  wildlifeContext: PropTypes.string.isRequired,
  activeClassFilter: PropTypes.number,
  countAmphibians: PropTypes.number,
  countMammals: PropTypes.number,
  countReptiles: PropTypes.number,
};

const mapStateToProps = (state, {wildlifeContext}) => ({
  activeClassFilter: state.wildlife[wildlifeContext].activeClassFilter,
  countAmphibians: state.wildlife[wildlifeContext].countAmphibians,
  countMammals: state.wildlife[wildlifeContext].countMammals,
  countReptiles: state.wildlife[wildlifeContext].countReptiles,
});

const mapDispatchToProps = {
  setClassFilter,
};

export { WildlifeClassSelector };
export default connect(mapStateToProps, mapDispatchToProps)(WildlifeClassSelector);



// WEBPACK FOOTER //
// ./src/components/WildlifeClassSelector.js